import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { fetchAllMyTasks } from "../services/tms";
import { roundNumber } from "../utils/roundNumber";
import { fetchOrganizations, fetchUsers } from "services/data";
import WisdomNavbar from "components/navbars/WisdomNabvar";
import TmsMyTasksCollapse from "components/ui/TmsMyTasksCollapse";
import { useNavigate } from "react-router-dom";

const WisdomMyTasks = () => {
    const { userInfo } = useAuth();
    const navigate = useNavigate();
    const [allAssigneeTasks, setAllAssigneeTasks] = useState([]);
    const [allAssignerTasks, setAllAssignerTasks] = useState([]);
    const [allReviewerTasks, setAllReviewerTasks] = useState([]);
    const [allManagerTasks, setAllManagerTasks] = useState([]);
    const [unfilteredAllReviewerTasks, setUnfilteredAllReviewerTasks] = useState([]);
    const [unfilteredAllAssigneeTasks, setUnfilteredAllAssigneeTasks] = useState([]);
    const [unfilteredAllAssignerTasks, setUnfilteredAllAssignerTasks] = useState([]);
    const [unfilteredAllManagerTasks, setUnfilteredAllManagerTasks] = useState([]);
    const [selectedMonthDetails, setSelectedMonthDetails] = useState({
        finishedPercentage: 0,
        avgManagerSpeed: 0,
        avgManagerQuality: 0,
        avgReviewerSpeed: 0,
        avgReviewerQuality: 0,
    });
    const [vtcs, setVtcs] = useState([]);
    const [selectedVtc, setSelectedVtc] = useState("");
    const [employees, setEmployees] = useState([]);
    const [unFilteredEmployees, setUnFilteredEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(userInfo.id);
    const [selectedImportance2, setSelectedImportance2] = useState("");

    const navItem = (label, path) => (
        <button
            onClick={() => {
                navigate(path);
            }}
            className={`relative bg-transparent text-black rounded-none shadow-none border-none px-2 py-1 group`}
        >
            <span
                className="font-bold relative z-10
            after:content-['']
            after:absolute
            after:left-0
            after:-bottom-[3px]
            after:h-[3px]
            after:rounded
            after:w-full
            after:bg-watomsBlue
            after:transform
            after:scale-x-0
            after:origin-left
            after:transition-transform
            after:duration-300
            group-hover:after:scale-x-100
          "
            >
                {label}
            </span>
        </button>
    );

    useEffect(() => {
        const loadVtcs = async () => {
            const response = await fetchOrganizations();
            const filteredVtcs = response.filter(vtc => vtc.id === 13 || vtc.id === 4 || vtc.id === 5 || vtc.id === 7 || vtc.id === 8 || vtc.id === 9)
            setVtcs(filteredVtcs)
        }

        const loadEmployees = async () => {
            const response = await fetchUsers(userInfo);
            setEmployees(response)
            setUnFilteredEmployees(response)
        }

        loadVtcs();
        loadEmployees();
    }, [])

    useEffect(() => {
        const filterData = () => {
            if (selectedVtc === "") {
                setEmployees(unFilteredEmployees)
            } else {
                setEmployees(unFilteredEmployees.filter(emp => Number(emp.employee.organization_id) === Number(selectedVtc)))
            }
        }

        filterData();
    }, [selectedVtc])

    useEffect(() => {
        const filterData = () => {
            const sortByEndDateDesc = (a, b) =>
                new Date(b.end_date) - new Date(a.end_date);
            if (selectedImportance2 === "") {
                calculateTmsDetails(unfilteredAllAssigneeTasks)
                setAllAssigneeTasks(unfilteredAllAssigneeTasks)
                setAllAssignerTasks(unfilteredAllAssignerTasks)
                setAllReviewerTasks(unfilteredAllReviewerTasks)
                setAllManagerTasks(unfilteredAllManagerTasks)
            } else {
                const allMyAssigneeTasks = unfilteredAllAssigneeTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByEndDateDesc);
                const allMyAssignerTasks = unfilteredAllAssignerTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByEndDateDesc);
                const allMyReviewerTasks = unfilteredAllReviewerTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByEndDateDesc);
                const allMyManagerTasks = unfilteredAllManagerTasks.filter(task => task.importance === selectedImportance2).slice().sort(sortByEndDateDesc);
                calculateTmsDetails(allMyAssigneeTasks)
                setAllAssigneeTasks(allMyAssigneeTasks)
                setAllAssignerTasks(allMyAssignerTasks)
                setAllReviewerTasks(allMyReviewerTasks)
                setAllManagerTasks(allMyManagerTasks)
            }
        }

        filterData();
    }, [selectedImportance2])

    const calculateTmsDetails = (data) => {
        const finishedTasksPercentage = data ? data?.filter(task => task.status === "finished" || task.status === "submitted").length : 0;
        const totalTasks = data ? data?.length : 0;
        const avgManagerSpeed = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.manager_speed_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;
        const avgManagerQuality = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.manager_quality_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;
        const avgReviewerSpeed = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.reviewer_speed_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;
        const avgReviewerQuality = data?.length
            ? roundNumber(
                data.reduce(
                    (sum, task) => sum + (Number(task.reviewer_quality_percentage) || 0),
                    0
                ) / data.length
            )
            : 0;

        setSelectedMonthDetails(prev => ({
            ...prev,
            finishedPercentage: finishedTasksPercentage ? roundNumber((Number(finishedTasksPercentage) / Number(totalTasks)) * 100) : 0,
            avgManagerSpeed, avgManagerQuality, avgReviewerSpeed, avgReviewerQuality,
        }));
    }

    useEffect(() => {
        const loadMyTasks = async () => {
            const response = await fetchAllMyTasks(selectedEmployee, "wisdom");
            const sortByEndDateDesc = (a, b) =>
                new Date(b.end_date) - new Date(a.end_date);
            const allMyAssigneeTasks = response.myAssigneeTasks.flatMap(month => month.tasks).slice().sort(sortByEndDateDesc);
            const allMyAssignerTasks = response.myAssignerTasks.flatMap(month => month.tasks).slice().sort(sortByEndDateDesc);
            const allMyReviewerTasks = response.myReviewerTasks.flatMap(month => month.tasks).slice().sort(sortByEndDateDesc);
            const allMyManagerTasks = response.myManagerTasks.flatMap(month => month.tasks).slice().sort(sortByEndDateDesc);
            calculateTmsDetails(allMyAssigneeTasks)
            setAllAssigneeTasks(allMyAssigneeTasks)
            setAllAssignerTasks(allMyAssignerTasks)
            setAllReviewerTasks(allMyReviewerTasks)
            setAllManagerTasks(allMyManagerTasks)
            setUnfilteredAllAssigneeTasks(allMyAssigneeTasks)
            setUnfilteredAllAssignerTasks(allMyAssignerTasks)
            setUnfilteredAllReviewerTasks(allMyReviewerTasks)
            setUnfilteredAllManagerTasks(allMyManagerTasks)
        }

        loadMyTasks();
    }, [selectedEmployee])
    return (
        <>
            {/* <TmsNavbar
                newTaskStatus={true}
                shareStatus={false}
                isFilter={isFilter}
                setIsFilter={setIsFilter}
                filterTmsStatus={true}
                addTaskPage={true}
            /> */}
            <WisdomNavbar
                shareStatus={false}
            >
                <div className={`hidden md:flex items-center gap-4 bg-gray-200 py-2 px-2 rounded-full shadow-lg shadow-black/30 w-fit`} >
                    {navItem("Dashboard", "/tms")}
                    {navItem("Add Task", "/wisdom/tms/add-task")}
                </div>
            </WisdomNavbar>
            <div className="flex flex-col gap-8 items-center min-h-[88vh] h-fit bg-[#0a183d] pt-1 text-white">
                <h1 className="text-2xl font-bold text-center text-yellow-500">عرض و تصنيف المهام</h1>
                {(userInfo?.code === 1 || userInfo?.code === 3 || userInfo?.code === 2) && <div className="w-fit flex md:flex-row flex-col gap-2 px-2">
                    <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            الاولوية
                        </label>
                        <select value={selectedImportance2} onChange={(e) => setSelectedImportance2(e.target.value)} className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار الاولوية</option>
                            <option value="urgent">قصوي</option>
                            <option value="important">متوسطة</option>
                            <option value="normal">عادية</option>
                        </select>
                    </div>

                    <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            المنفذيين
                        </label>
                        <select value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)} className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار المنفذ</option>
                            {employees.map(emp => (
                                <option value={emp.id}>{emp.employee.employee_first_name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            الجهة الفرعية
                        </label>
                        <select value={selectedVtc} onChange={(e) => setSelectedVtc(e.target.value)} className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار الجهة</option>
                            {vtcs.map(vtc => (
                                <option id={vtc.id} value={vtc.id}>{vtc.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* <div className="w-44 flex flex-col items-center">
                        <label className="text-sm font-semibold text-gray-200 mb-1">
                            الجهة الرئيسية
                        </label>
                        <select className="w-full text-center px-2 py-1 rounded-md bg-[#181f2e] text-white border border-gray-600 focus:border-[#0af] focus:outline-none cursor-pointer">
                            <option value="">الرجاء اختيار الجهة</option>
                            <option value="">الاختيار الاول</option>
                            <option value="">الاختيار الثاني</option>
                            <option value="">الاختيار الثالث</option>
                        </select>
                    </div> */}
                </div>}
                <div className="flex w-[95%] justify-between items-center">
                    <div className="flex flex-col">
                        <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اجمالي تقييم المهام</div>
                        <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2 ${roundNumber((((selectedMonthDetails.avgManagerSpeed + selectedMonthDetails.avgReviewerSpeed) / 2) * 0.3) + (((selectedMonthDetails.avgManagerQuality + selectedMonthDetails.avgReviewerQuality) / 2) * 0.3) + (selectedMonthDetails.finishedPercentage * 0.4)) < 50 && "text-red-500 font-bold"}`}>{roundNumber((((selectedMonthDetails.avgManagerSpeed + selectedMonthDetails.avgReviewerSpeed) / 2) * 0.3) + (((selectedMonthDetails.avgManagerQuality + selectedMonthDetails.avgReviewerQuality) / 2) * 0.3) + (selectedMonthDetails.finishedPercentage * 0.4))}%</div>
                    </div>
                    <div className="w-0 border-white border-l-2 h-12" />
                    <div className="flex gap-2">
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اولوية عادية</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.importance === "normal").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اولوية متوسطة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.importance === "important").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اولوية قصوي</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.importance === "urgent").length}</div>
                        </div>
                    </div>
                    <div className="w-0 border-white border-l-2 h-12" />
                    <div className="flex gap-2">
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهمة صغيرة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.size === "small").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهمة متوسطة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.size === "medium").length}</div>
                        </div>
                        <div className="flex flex-col">
                            <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>مهمة كبيرة</div>
                            <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.filter(task => task.size === "large").length}</div>
                        </div>
                    </div>
                    <div className="w-0 border-white border-l-2 h-12" />
                    <div className="flex flex-col">
                        <div className={`text-white text-center rounded p-2 bg-[#2f417a]`}>اجمالي عدد المهام</div>
                        <div className={`p-2 bg-white text-black rounded text-center font-bold mt-2`}>{allAssigneeTasks.length}</div>
                    </div>
                </div>
                <div className="h-0 border-t-2 border-white w-[60%]" />
                {/* My Tasks */}
                <TmsMyTasksCollapse
                    title="مهامي كمنفذ"
                    tasks={allAssigneeTasks}
                    bgColor="bg-[#5268b1]"
                    hoverColor="hover:bg-[#46599b]"
                    system="wisdom"
                />
                {/* Assigned Tasks */}
                <TmsMyTasksCollapse
                    title="مهام عينتها لغيري"
                    tasks={allAssignerTasks}
                    bgColor="bg-[#3d56aa]"
                    hoverColor="hover:bg-[#334994]"
                    system="wisdom"
                />
                {/* Reviewer Tasks */}
                <TmsMyTasksCollapse
                    title="مهامي كمراجع"
                    tasks={allReviewerTasks}
                    bgColor="bg-[#476adc]"
                    hoverColor="hover:bg-[#3958c5]"
                    system="wisdom"
                />
                {/* Manager Tasks */}
                <TmsMyTasksCollapse
                    title="مهامي كمدير"
                    tasks={allManagerTasks}
                    bgColor="bg-[#1c2952]"
                    hoverColor="hover:bg-[#5268b1]"
                    system="wisdom"
                />
            </div>
        </>
    )
}

export default WisdomMyTasks;